import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useGetAllUsersByGroupOptions } from '@/hooks/queries/groups';
import type { MentionUser } from '@/lib/data-transformers/comment';

/**
 * Cached directory of users for resolving `[user:id]` tokens in notification previews.
 */
export function useNotificationMentionUsers(): MentionUser[] {
  const { data } = useQuery(useGetAllUsersByGroupOptions(true));

  return useMemo(() => {
    const users = data?.data;
    if (!Array.isArray(users)) {
      return [];
    }
    return users as MentionUser[];
  }, [data?.data]);
}
